import { render, staticRenderFns } from "./doctoradviceStatis.vue?vue&type=template&id=86971eae&scoped=true"
import script from "./doctoradviceStatis.vue?vue&type=script&lang=js"
export * from "./doctoradviceStatis.vue?vue&type=script&lang=js"
import style0 from "./doctoradviceStatis.vue?vue&type=style&index=0&id=86971eae&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86971eae",
  null
  
)

export default component.exports